var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container grid"},[_c('div',{staticClass:"col-sm-12 col-md-6 text"},[_c('ContentOne')],1),_c('div',{staticClass:"col-md-6 img"},[_c('ImgContentOne')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }